import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { bootstrapAuthentication, finishAuthentication, authErrorKey } from '../utils/loginUtils';
import { authScreenUrl, extractLegacySessionToken } from '../utils/authHandoff';
import AuthCard from '../components/AuthCard';

export default function AuthCallback({ config }) {
  const { t } = useTranslation();
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    const failureCode = new URLSearchParams(window.location.search).get('error');
    if (failureCode) { extractLegacySessionToken(); setError(authErrorKey({ code: failureCode })); return undefined; }
    bootstrapAuthentication(config).then(async authenticated => {
      if (cancelled) return;
      if (!authenticated) { setError('authModern.errors.callback'); return; }
      if (config.enabled) await finishAuthentication(undefined, { sessionVerified: true });
      else window.location.replace(authScreenUrl('/'));
    }).catch(err => { if (!cancelled) setError(authErrorKey(err)); });
    return () => { cancelled = true; };
  }, [config]);
  return <AuthCard title="Noteician"><p role={error ? 'alert' : 'status'}>{t(error || 'authModern.completing')}</p>
    {error && <><a className="auth-link" href={authScreenUrl('/auth/sign-in')}>{t('auth.returnLogin')}</a><br /><a className="auth-link" href={authScreenUrl('/auth/connect-google')}>{t('authModern.connectGoogle')}</a></>}
  </AuthCard>;
}
